import { Record, Map } from 'immutable';
import { publishActions, retractActions } from './publish-intake-form.actions';
import * as api from '../../api';

/**
 * @property {Map<string, api.ApiCallState>} publishing the state of publish actions, indexed by the id of the intake form
 * @property {Map<string, api.ApiCallState>} retracting the state of retract actions, indexed by the id of the intake form
 */
export const PublishIntakeFormState = Record({
  publishing: Map({}),
  retracting: Map({}),
});

export const publishIntakeFormReducer = (initialState = new PublishIntakeFormState(), action) => {

  var state = initialState;
  if(action.id) {
    state = state.setIn(['publishing', action.id],
      api.apiCallReducer(state.getIn(['publishing', action.id]), action, publishActions));

    state = state.setIn(['retracting', action.id],
      api.apiCallReducer(state.getIn(['retracting', action.id]), action, retractActions));
  }

  switch (action.type) {
    default:
      return state
  }
}
